function parseQueryParams(search) {
    if (!search || search === '') return {};
    const params = {};
    search.replace(/^\?/, '').split('&').forEach(hash => {
        const [key, val] = hash.split('=');
        params[decodeURIComponent(key)] = decodeURIComponent(val);
    });
    return params;
}

export default parseQueryParams;



// WEBPACK FOOTER //
// ./src/lib/query-params.jsx